var drawingSetModes = {CLIENT: 'client', FACTORY: 'manufacturing'};
var invoiceModes = {CLIENT: 'client', FACTORY: 'manufacturing', PACKINGSLIP: 'packingSlip', INVOICE: 'invoice'};

export {drawingSetModes, invoiceModes};
